const env = process.env.VUE_APP_NODE_ENV
let urlObj = {
  'release': 'https://ump.ems.com.cn/ndwz/r/emURbq',
  'production': 'https://ump.ems.com.cn/ndwz/r/ne6fQb'
}
const url = urlObj[env]
export default url
